import React, {useEffect} from 'react'
import styled from '@emotion/styled'

import {cssTheme} from '@vio/atlas/src/themes'
import {linariaMq} from '@vio/atlas/src/utils/breakpoints'
import {useInView} from '@vio/core/src/_web/utils/browser/hooks/useInView'
import {useDispatchTeamEvent} from '@vio/core/src/analytics/hooks/useDispatchTeamEvent'
import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {Action, Category, Entity} from '@vio/core/src/analytics/types/Events'

import {AiPoweredReviewsPanel} from '../AiPoweredReviews/AiPoweredReviewsPanel'
import {AiPoweredReviewsSummary} from '../AiPoweredReviews/AiPoweredReviewsSummary'
import {useAiPoweredInsight} from '../AiPoweredReviews/useAiPoweredInsight'

const Wrapper = styled.div`
  grid-area: aiPoweredInsights;
  padding: 0 ${cssTheme.layout.spacing.s500};
  margin-top: ${cssTheme.layout.spacing.s700};
  ${linariaMq.desktopMd} {
    padding: 0;
  }
`

interface Props {
  hotelId: string
  mountedOnOverlay: boolean
  initialCategory: string
  onToggle: (category?: string) => void
  handleOpenAllReviews: () => void
}
export const ReviewSectionAiPoweredInsights: React.FC<Props> = ({
  hotelId,
  mountedOnOverlay,
  initialCategory,
  onToggle,
  handleOpenAllReviews
}) => {
  const dispatchTeamEvent = useDispatchTeamEvent()
  const {ref, inView} = useInView({triggerOnce: true, threshold: 0.2})

  const {isEnabled: isAiPoweredInsightsEnabled} = useAiPoweredInsight(hotelId)

  useEffect(() => {
    if (inView) {
      dispatchTeamEvent(
        trackEvent({
          category: Category.User,
          entity: Entity.AiReviewSummarySection,
          action: Action.Viewed,
          payload: {
            component: mountedOnOverlay
              ? 'ReviewsSectionOverlay'
              : 'ReviewsSection'
          }
        })
      )
    }
  }, [inView, dispatchTeamEvent, mountedOnOverlay])

  if (!isAiPoweredInsightsEnabled) return null

  return (
    <Wrapper>
      <div ref={ref}>
        <AiPoweredReviewsSummary
          hotelId={hotelId}
          onCategoryClick={category => onToggle(category)}
          onReadMoreClick={() => onToggle('overall')}
        />
      </div>
      <AiPoweredReviewsPanel
        hotelId={hotelId}
        initialCategory={initialCategory}
        onClose={() => onToggle()}
        onShowAllReviews={handleOpenAllReviews}
      />
    </Wrapper>
  )
}
